/**
 * Bidirectional translation between Calendar's URL `?status=` vocabulary and
 * the canonical saved-view enum (`status: 'queue'|'drafts'|'approvals'|'sent'`).
 *
 * Calendar's UI emits `?status=scheduled|draft|needs_approval|sent` (plus
 * `'all'` for "no filter"); the canonical store reuses the List view's
 * vocabulary so the same saved view can theoretically restore to either
 * surface. Saved views are URL bookmarks — Calendar's UI is what expands the
 * URL value back into a PostStatus set at render time.
 *
 * Defined once and the inverse derived programmatically so the two directions
 * cannot drift. `'all'` is intentionally absent — it represents "no filter,"
 * so `captureFilters` omits `filters.status` entirely.
 */

export const CALENDAR_STATUS_URL_TO_CANONICAL: Record<string, string> = {
  scheduled: 'queue',
  draft: 'drafts',
  needs_approval: 'approvals',
  sent: 'sent',
}

export const CANONICAL_TO_CALENDAR_STATUS_URL: Record<string, string> =
  Object.fromEntries(
    Object.entries(CALENDAR_STATUS_URL_TO_CANONICAL).map(([url, canonical]) => [
      canonical,
      url,
    ]),
  )
